export class ServiceValue {
    id: number;
    clientServiceVO: ClientService;
    description: string;
}

export class ClientService {
    id: number;
    service: string;
    category: ServiceType;
    description: string;
    selected: boolean;
}

export enum ServiceType {
    TRUSTEE = <any>'Act as trustee',
    DOMICILE_SEC = <any>'Domicile sec',
    DOMICILE_PLUS = <any>'Domicile plus',
    MGT_SVC = <any>'Management Services',
    MEDIATE_SELLING = <any>'Mediate in selling the company',
    PARTNER = <any>'Partner',
    SUPPLY_CONDUIT_COMPANY = <any>'Supplying a coduit company',
    OTHER = <any>'Other'
}



// WEBPACK FOOTER //
// ./src/app/entities/details/services/client-service.model.ts